module.exports = __webpack_public_path__ + "static/img/a01.3e50e7dc.jpg";